// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Woar","label":"Radio_label__24iIh","checkMark":"Radio_checkMark__w5oLr","disabled":"Radio_disabled__2AjB0"};